import { render, staticRenderFns } from "./LinkBtn.vue?vue&type=template&id=db0bafee&scoped=true&"
import script from "./LinkBtn.vue?vue&type=script&lang=ts&"
export * from "./LinkBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0bafee",
  null
  
)

export default component.exports